export const beregnetLuftmengdePerVolum = (avkastLuftmengde: number, kabinettvolum: number): number => {
  if (avkastLuftmengde == null || isNaN(avkastLuftmengde) || kabinettvolum == null || isNaN(kabinettvolum)) {
    return NaN;
  } else {
    return avkastLuftmengde / kabinettvolum;
  }
};
